<script setup lang="ts">
import { useEnqueteNewPageQuery } from './EnqueteNewPage.generated'
import EnqueteNewPageContent from './EnqueteNewPageContent.vue'

const pageQuery = useEnqueteNewPageQuery({
  fetchPolicy: 'no-cache',
})
</script>

<template>
  <section :class="$style.wrapper">
    <div :class="$style.container">
      <EnqueteNewPageContent
        v-if="pageQuery.result.value"
        :user-variable-definitions="
          pageQuery.result.value.userVariableDefinitions
        "
      />
    </div>
  </section>
</template>

<style module lang="scss">
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 auto;
  width: 860px;
}

.container {
  background-color: $color-surface-primary;
  padding: 16px;
  border-radius: 10px;
}
</style>
